const loginMixin = require('./login-mixin')

export {
  loginMixin
}



// WEBPACK FOOTER //
// ./src/mixins/index.js